
<template>
    
        <mars-view v-if="qaList && qaList.length" class="knowledge-list-box"><mars-view class="title">法律知识科普</mars-view><mars-view v-for="item,index in qaList" :key="index" class="knowledge-item-box" @click.native="gotoQuestion(item)"><mars-view class="title-box"><mars-view class="icon-box"></mars-view><mars-view class="title lineclamp1">{{ item.qaQuestion }}</mars-view></mars-view><mars-view v-if="item.expertInfo && item.expertInfo.qc_no" class="lawyer-info-box"><mars-view v-if="item.expertInfo.avatar" class="avatar-box"><mars-view class="avatar" :style="'background-image: url(' + item.expertInfo.avatar + ')'"></mars-view></mars-view><mars-view v-if="item.expertInfo.name" class="name">{{ item.expertInfo.name }}</mars-view><mars-view v-if="item.expertInfo.pranticeYear" class="years">
                {{ item.expertInfo.pranticeYear }}
            </mars-view><mars-view v-if="item.expertInfo.pracCompany" class="company">{{ item.expertInfo.pracCompany }}</mars-view></mars-view><mars-view class="content lineclamp2">
            {{ item.qaAnswer }}
        </mars-view></mars-view></mars-view>
    
</template>

<script>
import { act } from '../../../static/utils/navigate';
import log from '../../../static/utils/ubcLog';
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    qaList() {
      return this.info.legal_qa && this.info.legal_qa.qa_list || [];
    },
    optype() {
      return this.info && this.info.optype || '';
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 跳转到问答详情页
     * @param {Object} item 问答对象
     */

    gotoQuestion(item = {}) {
      let {
        qid
      } = item;
      if (!qid) {
        return;
      }
      log.send({
        area: this.info.selectType,
        action: 'click',
        serverId: 17510,
        optype: this.optype
      });
      log.send({
        area: 'pref_guide',
        action: 'click',
        serverId: 17260,
        optype: this.optype
      });
      act({
        target: `/pages/qalandpage/struct?qid=${qid}&fr=${this.optype || ''}&isUseFr=1`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.knowledge-list-box {
  margin-top: 1.93vw;
  padding: 6.52vw 4.11vw 0;
  background-color: #fff;
}
.knowledge-list-box .lineclamp2 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.knowledge-list-box .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.knowledge-list-box .title {
  color: #1e1f24;
  font-family: "PingFang SC";
  font-size: 4.11vw;
  font-style: normal;
  font-weight: 500;
  line-height: 4.11vw;
}
.knowledge-list-box .knowledge-item-box {
  padding: 4.83vw 0 3.62vw;
}
.knowledge-list-box .knowledge-item-box:not(:last-child) {
  border-bottom: #e8e8e8 solid 1rpx;
}
.knowledge-list-box .knowledge-item-box .title-box {
  display: flex;
  align-items: center;
}
.knowledge-list-box .knowledge-item-box .title-box .icon-box {
  flex-shrink: 0;
  width: 4.35vw;
  height: 4.35vw;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/activity/index/wen-icon.png') no-repeat center center / 100% 100%;
  border-radius: 3px;
  margin-right: 1.61vw;
}
.knowledge-list-box .knowledge-item-box .title-box .title {
  flex-shrink: 1;
}
.knowledge-list-box .knowledge-item-box .lawyer-info-box {
  margin-top: 3.38vw;
  display: flex;
  align-items: center;
  color: #848691;
  font-family: "PingFang SC";
  font-size: 3.38vw;
  font-style: normal;
  font-weight: 400;
  line-height: 3.38vw;
}
.knowledge-list-box .knowledge-item-box .lawyer-info-box .avatar-box {
  width: 4.43vw;
  height: 4.43vw;
  border-radius: 50%;
  background-color: #1e1f24;
  overflow: hidden;
  margin-right: 1.45vw;
}
.knowledge-list-box .knowledge-item-box .lawyer-info-box .avatar-box .avatar {
  width: 4.43vw;
  height: 4.43vw;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.knowledge-list-box .knowledge-item-box .lawyer-info-box .name,
.knowledge-list-box .knowledge-item-box .lawyer-info-box .years {
  margin-right: 1.45vw;
}
.knowledge-list-box .knowledge-item-box .content {
  margin-top: 2.42vw;
  color: #50525c;
  font-family: "PingFang SC";
  font-size: 3.62vw;
  font-style: normal;
  font-weight: 400;
  line-height: 6.04vw;
}

</style>
